import React from 'react';
import { StaticQuery, graphql } from "gatsby";
import { getArticleOrCategorySlugs } from '../../utilities';
import Slider from 'react-slick';
import get from 'lodash/get';
import { Image } from '../Common/Image';

const NewArticles = () => {
     return <StaticQuery
          query={graphql`
               query NewArticlesQuery {
                    allContentfulHzArticle(limit: 7, sort: {fields: createdAt, order: DESC}) {
                         edges {
                              node {
                                   ...ContentfulHzArticleFields
                              }
                         }
                    }
               }
          `}
          render={
               data => {
                    const articles = get(data, 'allContentfulHzArticle.edges');
                    if (articles.length === 0) {
                         return <></>;
                    }
                    const firstRecentArticleSlug = '/healthzone/' + getArticleOrCategorySlugs(articles[0].node.category).reverse().join('/') + '/' + articles[0].node.slug + '/';
                    const settings = {
                         autoplay: false,
                         dots: false,
                         arrows: true,
                         infinite: true,
                         speed: 500,
                         slidesToScroll: 1,
                         variableWidth: true,
                         responsive: [
                              {
                                   breakpoint: 361,
                                   settings: {
                                        slidesToShow: 1,
                                        variableWidth: false,
                                   }
                              }
                         ]
                    };

                    return (
                         <section className={`home-articles recent-articles`}>
                              <div className="container recent-articles-container">
                                   <div className="first-article">
                                        <div className="row">
                                             <div className="col-lg-8 first-article-left">
                                                  <a href={firstRecentArticleSlug} tabIndex={-1}>
                                                       {articles[0].node.featuredImage ? (<Image image={articles[0].node.featuredImage} />) : <img src="/images/no-dog.png" alt="no-dog" />}
                                                  </a>
                                             </div>
                                             <div className="col-lg-4 first-article-right">
                                                  <div className="content">
                                                       {articles[0].node.contentName && (
                                                            <a href={firstRecentArticleSlug}>
                                                                 <h1>{articles[0].node.contentName}</h1>
                                                            </a>
                                                       )}
                                                       {articles[0].node.shortDescription && <p>{articles[0].node.shortDescription}</p>}
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                              <div className="container">
                                   <div className="desktop">
                                        <div className="recent-article-slider">
                                             <div className="row articles-wrap">
                                                  {
                                                       articles.map(({ node }, i) => {
                                                            let slugs = '/healthzone/' + getArticleOrCategorySlugs(node.category).reverse().join('/') + '/' + node.slug + '/';

                                                            if (i != 0) {
                                                                 return (
                                                                      <div className="col-sm-4 article-block" key={i}>
                                                                           <div className="article-slider-detail article-detail">
                                                                                <div className="image-wrap">
                                                                                     <a href={slugs} tabIndex={-1}>
                                                                                          {node.featuredImage ? <Image image={node.featuredImage} altOverride={(node.contentName) ? node.contentName : ''} /> : <img src="/images/no-dog.png" alt="no-dog" />}
                                                                                     </a>
                                                                                </div>
                                                                                <div className="content">
                                                                                     {node.contentName && (
                                                                                          <a href={slugs}>
                                                                                               <h3>{node.contentName}</h3>
                                                                                          </a>
                                                                                     )}
                                                                                     {node.shortDescription && <p>{node.shortDescription}</p>}
                                                                                </div>
                                                                           </div>
                                                                      </div>
                                                                 )
                                                            }
                                                       })
                                                  }
                                             </div>
                                        </div>
                                   </div>
                              </div>
                              <div className="mobile">
                                   <div className="recent-article-slider">
                                        <div className="slider-container">
                                             <div className="recent-article-slider">
                                                  <Slider {...settings}>
                                                       {
                                                            articles.map(({ node }, i) => {
                                                                 let slugs = '/healthzone/' + getArticleOrCategorySlugs(node.category).reverse().join('/') + '/' + node.slug + '/';
                                                                 if (i != 0) {
                                                                      return (
                                                                           <div className="article-slider-detail" key={i}>
                                                                                <a href={slugs} tabIndex={-1}>
                                                                                     {node.featuredImage ? <Image image={node.featuredImage} /> : <img src="/images/no-dog.png" alt="no-dog" />}
                                                                                </a>
                                                                                <div className="content">
                                                                                     <a href={slugs}>{node.contentName && <h3>{node.contentName}</h3>}</a>
                                                                                     {node.shortDescription && <p>{node.shortDescription}</p>}
                                                                                </div>
                                                                           </div>
                                                                      )
                                                                 }
                                                            })
                                                       }
                                                  </Slider>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </section>
                    )
               }
          }
     />;
}

export default NewArticles;
